/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./plugins');
require('./plugins/magnific-popup/dist/jquery.magnific-popup');
window.smoothScroll = require('./plugins/smooth-scroll/smooth-scroll.min');
window.scrollReveal = require('./plugins/scrollreveal/scrollreveal');

require('./dosis.custom');
require('./plugins/cubeportfolio/js/jquery.cubeportfolio.min');

require('./cube-awesome-work');
require('./plugins/smart-form/contact/js/jquery.form.min');
require('./plugins/smart-form/contact/js/jquery.validate.min');
require('./plugins/smart-form/contact/js/additional-methods.min');
require('./plugins/smart-form/contact/js/smart-form');
require('./plugins/sticky/jquery.sticky');


var site = {
    toFilter: {},
    modalInteraction: false,
    currentModalName: '',
    init: function () {
        this.initCookieBar();
        this.handlers();
        this.vacancyFilter();
        this.favorites();
        setTimeout(function () {
            window.site.ajaxModals();

        }, 1000);
        this.ajaxForms();
        this.modalInteractionTrigger();
        this.mobileFilterPanelButton();


         $('body').on('hidden.bs.modal', function () {
            if($('.modal.show').length > 0)
            {
                $('body').addClass('modal-open');
            }
        });
    },
    initCookieBar: function () {
        $('.consent-agree-btn').bind('click', function () {
            $('.cookie-bar').hide();
            var $elm = $(this);

            if ($('#cookieconsent_marketing').attr('checked') == 'checked') {
                setCookie('cookieconsent-marketing', 1, 30);
            } else {
                deleteCookie('cookieconsent-marketing');
            }
            setCookie('cookieconsent-agreed', 1, 30);
            window.location = window.location;
        });
        if (getCookie("cookieconsent-agreed") == "") {
            $('.cookie-bar').removeClass('hidden');
        }
        this.initGTMTrigger();

    },
    initGTMTrigger: function () {
        //$('[data-gtm]').unbind('click', window.site.GTMTrigger).bind('click', window.site.GTMTrigger);
    },
    GTMTrigger: function () {
        var $me = $(this);
        var category = $me.data('category');
        var action = $me.data('action');

        var label = $me.data('label');
        var value = $me.data('value');

        //  if(action==undefined) {
        action = label;
        label = value;
        //  }

        var dataObject = {
            'event': 'global_trigger',
            'category': category,
            'action': action,
            'label': label,
            'value': value,
        };
        if (typeof dataLayer != 'undefined') {
            dataLayer.push(dataObject);
        }
    },
    modalInteractionTrigger: function () {
        window.site.modalInteraction = false;
        window.site.currentModalName = '';
        $('.modal-body').bind('click', function () {
            window.site.modalInteraction = true;
        });
        $('.modal').on('shown.bs.modal', function (e) {
            window.site.modalInteraction = false;
            if ($(this).find('.modal-header').length > 0) {
                window.site.currentModalName = $(this).find('.modal-header').first().text().trim();
            } else {
                window.site.currentModalName = $(this).attr('id');
            }
        });
        $('.modal').on('hidden.bs.modal', function (e) {
            if (!window.site.modalInteraction) {
                // console.log('geen interactie');
                var dataObject = {
                    'event': 'modal_no_interaction',
                    'label': window.site.currentModalName,
                    'modalname': window.site.currentModalName
                };
                if (typeof dataLayer != 'undefined') {
                    dataLayer.push(dataObject);
                }
            } //else {
            //    console.log('wel interactie');
            // }
            window.site.modalInteraction = false;
        });
    },
    ajaxModals: function () {
        $('.modal').on('show.bs.modal', function () {
            var $me = $(this);
            $('[data-toggle="tooltip"]').tooltip();
            if ($me.data('getpage')) {
                $.get('/pagedata/' + $me.data('getpage'), function (response) {
                    $me.find('.modal-title').html(response.title);
                    $me.find('.modal-body').html(response.body);
                    $me.find('[data-toggle="tooltip"]').tooltip();
                    window.site.ajaxForms();
                });
            }
            window.site.ajaxForms();
        }).on('hidden.bs.modal', function () {

            var $me = $(this);
            if ($me.data('getpage')) {
                $me.find('.modal-title').html('');
                $me.find('.modal-body').html('');
            }
        });
    },
    ajaxForms: function () {

        $('form[data-ajaxform]').find('.form-group[data-showwhen]').each(function (s, e) {
            var _showwhen = $(this).data('showwhen').split('=');
            var elm = _showwhen[0];
            var requirement = _showwhen[1];
            var $target = $('[name="' + elm + '"]');
            if ($target) {

                var toggleTarget = $('.form-group[data-showwhen="' + $(this).data('showwhen') + '"]');
                if (requirement == 'checked') {
                    if ($target.is(':checked')) {
                        $(toggleTarget).removeClass('hidden');
                    } else {
                        $(toggleTarget).addClass('hidden');
                    }
                    $target.data('showwhentarget', toggleTarget);
                    $target.unbind('change').bind('change', function () {
                        $($(this).data('showwhentarget')).toggleClass('hidden');
                    });
                }
                if (requirement == 'unchecked') {
                    if (!$target.is(':checked')) {
                        $(toggleTarget).removeClass('hidden');
                    } else {
                        $(toggleTarget).addClass('hidden');
                    }
                    $target.data('showwhentarget', toggleTarget);
                    $target.unbind('change').bind('change', function () {
                        $($(this).data('showwhentarget')).toggleClass('hidden');
                    });
                }
            }

        });

        $('form[data-ajaxform]').bind('submit', function (event) {
            event.preventDefault();
            $form = $(this);
            $response = $('#' + $(this).attr('id') + '-response');

            $form.find('.form-group').addClass('hidden');
            $form.find('.hide-after-submit').addClass('hidden');
            $form.find('.busy').removeClass('hidden');
            var form_data = new FormData($(this)[0]);


            var url = $(this).attr('action');

            if ($form.data('recaptcha')) {
                grecaptcha.execute(recaptchasitekey, {
                    action: 'pageview'
                }).then(function (token) {
                    form_data.append('gRecaptchaResponse', token);
                    $.ajax({
                        type: 'POST',
                        url: url,
                        processData: false,
                        contentType: false,
                        cache: false,
                        data: form_data,
                        success: function (response) {
                            $form.find('.busy').addClass('hidden');
                            $form.find('.hide-after-submit').addClass('hidden');
                            $response.removeClass('hidden');
                            $form.find('.response').removeClass('hidden')

                            var dataObject = {
                                'event': 'form_sent',
                                'form': $form.data('formname')
                            };
                            if (typeof dataLayer != 'undefined') {
                                dataLayer.push(dataObject);
                            }
                        },
                        error: function (response) {
                            $form.find('.busy').addClass('hidden');
                            $form.find('.hide-after-submit').addClass('hidden');
                            $form.find('.response-error').removeClass('hidden');
                            var dataObject = {
                                'event': 'form_error',
                                'form': $form.data('formname')
                            };
                            if (typeof dataLayer != 'undefined') {
                                dataLayer.push(dataObject);
                            }
                        }
                    });

                });
            } else {
                $.ajax({
                    type: 'POST',
                    url: url,
                    processData: false,
                    contentType: false,
                    cache: false,
                    data: form_data,
                    success: function (response) {
                        $form.find('.busy').addClass('hidden');
                        $form.find('.hide-after-submit').addClass('hidden');
                        $response.removeClass('hidden');
                        $form.find('.response').removeClass('hidden')

                        var dataObject = {
                            'event': 'form_sent',
                            'form': $form.data('formname')
                        };
                        if (typeof dataLayer != 'undefined') {
                            dataLayer.push(dataObject);
                        }
                    },
                    error: function (response) {
                        $form.find('.busy').addClass('hidden');
                        $form.find('.hide-after-submit').addClass('hidden');
                        if(response.responseJSON.message) {
                            $form.find('.response-error')
                                .html(response.responseJSON.message);
                        }
                        $form.find('.response-error').removeClass('hidden');
                        var dataObject = {
                            'event': 'form_error',
                            'form': $form.data('formname')
                        };
                        if (typeof dataLayer != 'undefined') {
                            dataLayer.push(dataObject);
                        }
                    }
                });
            }




            return false;
        }).removeAttr('data-ajaxform');

    },
    handlers: function () {

        $('.contact-trigger').on('click', function () {
            $(this).toggleClass('active');
        });
        $('.contact-trigger').on('mouseover', function () {
            $(this).addClass('active');
        });
        $('#cookie-consent-agree').bind('click', function () {
            var dataObject = {
                'event': 'cookieconsent',
                'agree': 'allow_all'
            };
            if (typeof dataLayer != 'undefined') {
                dataLayer.push(dataObject);
            }
        });
        $('#cookie-consent-decline').bind('click', function () {
            var dataObject = {
                'event': 'cookieconsent',
                'agree': 'only_functional'
            };
            if (typeof dataLayer != 'undefined') {
                dataLayer.push(dataObject);
            }
        });
        $('[data-toggle="tooltip"]').tooltip();

        $('.disabled a').attr('href', 'javascript:;');

        $('.clickable-block').on('click', function () {
            var href = $(this).find('a[href]');
            if (href.length > 0) {
                window.location = $(href).first().attr('href');
            }
        });


        $('[data-showall="true"]').bind('click', function () {
            $(this).hide();
            $('.vacancy-row[hidden]').removeAttr('hidden');
            $('.open-application').addClass('hidden').attr('hidden', 'hidden');
        });
        site.moveVacancyTextBlockToPosition();

        if ($('.carousel-inner .carousel-item').length === 1) {
            $('.hide-on-solo-slide').hide();
        };

    },
    moveVacancyTextBlockToPosition: function () {
        if ($('div.vacancy-textblock-row').length > 0) {
            var visible = $('div.vacancy-row:not([hidden])');
            var position = visible.length >= 5 ? 3 : visible.length - 1;
            $('div.vacancy-textblock-row').insertAfter(visible[position]);
        }
    },
    mobileFilterPanelButton: function () {
        $('.show-filterpanel').on('click', function () {
            $('.job-filter').removeClass('d-none');
            $(this).remove();
        });
    },
    favorites: function () {
        $('a[data-favorite]').on('click', function () {
            if ($(this).attr('data-isfavo') == true || $(this).attr('isfavo') == '1') {

                if ($(this).data('istext')) {
                    $(this).removeClass('saved');
                    $(this).text('Bewaren');
                }

                $.get('/removefavorite/' + $(this).attr('data-favorite'));
                $(this).attr('data-isfavo', '0');
                var newCount = parseFloat($('.number-saved:first').text()) - 1;
                if (newCount < 0) {
                    newCount = 0;
                }
                $('.number-saved').text(newCount);

            } else {
                $.get('/addfavorite/' + $(this).attr('data-favorite'));

                if ($(this).data('istext')) {
                    $(this).addClass('saved');
                    $(this).text('Bewaard');
                }


                $(this).attr('data-isfavo', '1');
                if ($('.number-saved').text() == 0) {
                    $('.number-saved').removeAttr('hidden');
                    $('.number-saved').text(1);
                } else {
                    $('.number-saved').text(parseFloat($('.number-saved:first').text()) + 1);
                }
            }
        });

    },
    refineURL: function () {
        //get full URL
        var currURL= window.location.href; //get current address
        var beforeQueryString= currURL.split("?")[0];

        return beforeQueryString;
    },
    vacancyFilter: function() {

        return beforeQueryString;
    },
    vacancyFilter: function () {

        $('#clearSearchFilter').on('click', function () {
            $('#vacancy_filter').val('');
            window.location = window.site.refineURL();//'/vacatures-in-de-zorg';
        });

        $('a[data-clearfilter="true"]').on('click', function () {
            $('.filter-value:checked').prop('checked', false).trigger('change');
        });

        $('#vacancy_filter').bind('change', function () {
            if ($(this).val().length > 0) {
                let searchFor = encodeURI($(this).val());
                //console.log(searchFor);
                window.location = '?search=' + searchFor;
            }
        });

        $('.filter-value').on('change', function () {
            $(this).parents('.form-check').first().toggleClass('checked');
            $('a[data-showall="true"]').attr('hidden', 'hidden');
            window.site.toFilter = {};
            var appliedFilters = '';
            var hasFilter = $(this).val().length > 0;
            $('.filter-value:checked').each(function (a, b) {
                hasFilter = true;
                if (!window.site.toFilter.hasOwnProperty($(b).data('filter'))) {
                    window.site.toFilter[$(b).data('filter')] = [];
                }
                window.site.toFilter[$(b).data('filter')].push($(b).val());
            });

            if (hasFilter) {

                $('#appliedFilters').removeAttr('hidden');
                $('.vacancy-row').addClass('hidden').attr('hidden', 'hidden').attr('data-hitcount', 0);

                var calc = 10;

                for (var filterType in window.site.toFilter) {
                    calc++;
                    window.site.toFilter[filterType].forEach(function (a, b) {

                        if(filterType == 'location' ) {

                            $('.vacancy-row[data-locations*="' + a + '"]').each(function (a, b) {
                                //console.log(b);
                                var newHitCount = parseFloat($(b).attr('data-hitcount')) + 10;
                                $(b).attr('data-hitcount', newHitCount);
                            });


                        } else if(filterType == 'department') {
                            $('.vacancy-row[data-virtualdepartments*="' + a + '"]').each(function (a, b) {
                                //console.log(b);
                                var newHitCount = parseFloat($(b).attr('data-hitcount')) + 10;
                                $(b).attr('data-hitcount', newHitCount);
                            });
                        } else if(filterType == 'department-vrij') {
                            $('.vacancy-row[data-department="' + a + '"]').each(function (a, b) {
                                //console.log(b);
                                var newHitCount = parseFloat($(b).attr('data-hitcount')) + 10;
                                $(b).attr('data-hitcount', newHitCount);
                            });
                        } else if (filterType == 'hours') {
                            $('.vacancy-row[data-' + filterType + '*="-' + a + '-"]').each(function (a, b) {
                                //console.log(b);
                                var newHitCount = parseFloat($(b).attr('data-hitcount')) + 10;
                                $(b).attr('data-hitcount', newHitCount);
                            });
                        } else {
                            $('.vacancy-row[data-' + filterType + '="' + a + '"],.vacancy-row[data-' + filterType + '2="' + a + '"]').each(function (a, b) {
                                //console.log(b);
                                var newHitCount = parseFloat($(b).attr('data-hitcount')) + 10;
                                $(b).attr('data-hitcount', newHitCount);
                            });
                        }


                        appliedFilters += '<span class="active-filter-label"><span class="d-inline-block">' + $('.filter-value[value="' + a + '"]').first().parent().find('label').find('span').text() + '</span><span class="sep d-inline-block">/</span></span>';
                    });

                };
                var minHitCount = Object.keys(window.site.toFilter).length * 10;
                //    $('.vacancy-row[data-hitcount="' + minHitCount + '"]').removeClass('hidden').removeAttr('hidden');

                $('.vacancy-row').filter(function () {
                    return $(this).attr("data-hitcount") >= minHitCount;
                }).removeClass('hidden').removeAttr('hidden');


            } else {
                $('#appliedFilters').attr('hidden', 'hidden');
                $('.vacancy-row').removeClass('hidden').removeAttr('hidden');
                $('.open-application').addClass('hidden').attr('hidden', 'hidden');

            }

            if (appliedFilters.length < 2) {
                $('#appliedFilters').attr('hidden', 'hidden');
            }
            $('#appliedFilters .card-body').html(appliedFilters);

            site.moveVacancyTextBlockToPosition();
            //setTimeout(function() {
            var options = {
                speed: 1000,
                easing: 'easeOutCubic'
            };

            window.smoothScroll.animateScroll(document.querySelector('.section-title'), false, options); // widget-vacatureoverzicht
            //},500);
            if ($('.vacancy-row:visible').length == 0) {

                $('.open-application').filter(function () {
                    return $(this).attr("data-hitcount") >= 10;
                }).removeClass('hidden').removeAttr('hidden');

                if ($('.open-application:visible').length == 0) {
                    $('.main-open-application').removeAttr('hidden').removeClass('hidden');
                    //$('.no-filter-match').removeAttr('hidden');
                }
                // else {
                //     $('.no-filter-match').attr('hidden', 'hidden');
                // }

            } else {
                $('.open-application').addClass('hidden').attr('hidden', 'hidden');
                $('.main-open-application').addClass('hidden').attr('hidden', 'hidden');
                $('.no-filter-match').attr('hidden', 'hidden');
            }

            if ($('.main-open-application:visible').length == 0 && $('.open-application:visible').length == 0 && $('.vacancy-row:visible').length == 0) {
                $('.no-filter-match').removeAttr('hidden');
            } else {
                $('.no-filter-match').attr('hidden', 'hidden');
            }
            $('.vacancy-total').text($('.vacancy-row:visible').length);

        });


    }
}


// COOKIE CONSENT COOKIE FUNCTIONS
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// Delete cookie
function deleteCookie(cname) {
    let expires = "expires=Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = cname + "=;" + expires + ";path=/";
}

window.site = site;
$(function () {
    window.site.init();
});
